export { default } from './copy'
